import styled from 'styled-components';
import { theme } from '../../../theme';

export const ItemCardLower = styled.div`
  box-sizing: border-box;
  display: block;
  width: 100%;
  padding: ${theme.spacings[3].rem};
`;
